import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginContainer from "../components/atomic/molecular/LoginContainer";
import PrimaryLinkButton from "../components/atomic/ui/PrimaryLinkButton";
import Teams from "../components/atomic/molecular/Teams";
import SubmitButton from "../components/login/SubmitButton";
import DividerSnsLabel from "../components/atomic/ui/DividerSnsLabel";
import GoogleButton from "../components/atomic/ui/GoogleButton";
import Email from "../components/atomic/ui/input/Email";
import Password from "../components/atomic/ui/input/Password";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Divider,
  Typography,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

function SignUp() {
  const navigate = useNavigate();
  const [isSignedUp, setIsSignedUp] = useState(false);
  const [isErrorAlreadyExists, setIsErrorAlreadyExists] = useState(false);
  const [isRead, setIsRead] = useState(false);

  const navigateMypage = () => {
    navigate("/mypage/accounts");
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    try {
      if (email === "" || password === "") {
        alert("メールアドレスとパスワードを入力してください");
        return null;
      }
      setIsSignedUp(true);
      await Auth.signUp({
        username: email,
        password: password,
        attributes: {
          email: email,
        },
      });
      setIsSignedUp(false);
      localStorage.setItem("signUpEmail", email);
      navigate("/signup/conform");
    } catch (e) {
      console.log(e);
      setIsSignedUp(false);
      if (e.code === "UsernameExistsException") {
        localStorage.setItem("signUpEmail", email);
        setIsErrorAlreadyExists(true);
        window.scrollTo(0, 0);
      }
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      await Auth.federatedSignIn({ provider: "Google" });
      navigate("/wait");
    } catch (e) {
      console.log(e);
    }
  };

  const handleSignUpStatus = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (!!user) {
        navigateMypage();
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    navigate("/");
    // handleSignUpStatus();
  }, []);

  return (
    <LoginContainer label={"ナッシュアンバサダープログラム会員登録"}>
      {isErrorAlreadyExists && (
        <Card
          sx={{
            margin: "32px 0px 16px",
            border: "2px solid #ddd",
            textAlign: "center",
            padding: "16px 16px 32px",
          }}
        >
          <div>
            <p>すでに登録されているメールアドレスです</p>
            <Box sx={{ margin: "16px" }}>確認コードを入力しますか？</Box>
            <PrimaryLinkButton label={"入力する"} to={"conform"} />
          </div>
        </Card>
      )}
      <Teams setIsRead={setIsRead} isRead={isRead} />
      <Box sx={{ marginTop: "32px" }}>
        <GoogleButton
          onClick={handleGoogleSignUp}
          disabled={!isRead}
          label="Googleで登録"
          id={"cta_amb_google"}
        />
      </Box>
      <Box sx={{ marginTop: "32px" }}>
        <form onSubmit={handleSignUp}>
          <Accordion
            sx={{
              border: "2px solid #ddd",
            }}
            disabled={!isRead}
          >
            <AccordionSummary aria-controls="panel1a-content" id="panelHead">
              <EmailIcon
                sx={{
                  color: "primary.main",
                  marginRight: "8px",
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  メールアドレスで登録
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <>
                <Email />
                <Password />
                <SubmitButton
                  buttonLabel={"登録する"}
                  isLoading={isSignedUp}
                  disabled={!isRead}
                />
              </>
            </AccordionDetails>
          </Accordion>
        </form>
      </Box>
    </LoginContainer>
  );
}

export default SignUp;
